var map = {
	"./sdg-1-no-poverty.png": 556,
	"./sdg-10-request-inequalities.png": 557,
	"./sdg-11-sustainable-cities.png": 558,
	"./sdg-12-responsible-consumption.png": 559,
	"./sdg-13-climate-action.png": 560,
	"./sdg-14-life-below-water.png": 561,
	"./sdg-15-life-on-land.png": 562,
	"./sdg-16-peace-and-justice.png": 563,
	"./sdg-17-partnerships.png": 564,
	"./sdg-2-zero-hunger.png": 565,
	"./sdg-3-good-health.png": 566,
	"./sdg-4-quality-education.png": 567,
	"./sdg-5-gender-equality.png": 568,
	"./sdg-6-clean-water.png": 569,
	"./sdg-7-affordable-clean-energy.png": 570,
	"./sdg-8-decnet-work.png": 571,
	"./sdg-9-industry.png": 572
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 202;